<div class="flex p-2 text-lg font-semibold">
  {{ ((isEditing$ | async) ? 'Kommentar bearbeiten' : 'Neues Kommentar erstellen') | translate }}
</div>

@if ({ content: (input$ | async) ?? '' }; as input) {
  <div class="mt-2 px-2">
    <soft-multiline-input
      [lines]="7"
      [value]="input.content"
      (valueChange)="input$.next($event ?? '')">
    </soft-multiline-input>
    <div class="flex justify-between items-center gap-3 mt-3">
      <button class="soft-button secondary !w-full" (click)="close(undefined)">Abbrechen</button>
      <button class="soft-button primary !w-full" (click)="close(input)" [disabled]="!input?.content || (input?.content?.length ?? 0) < 1">
        {{ ((isEditing$ | async) ? 'Speichern' : 'Erstellen') | translate }}
      </button>
    </div>
  </div>
}

